'use client'

import { Builder, withChildren } from '@builder.io/react'

import { clickActionInputs } from '@src/hooks/useClickAction/useClickAction.builder'

import { Button, ButtonSizes, ButtonVariants } from './Button'

Builder.registerComponent(withChildren(Button), {
  name: 'Button',
  noWrap: true,
  inputs: [
    ...clickActionInputs,
    {
      name: 'disabled',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'variant',
      type: 'text',
      enum: ButtonVariants as any,
      defaultValue: ButtonVariants[0],
    },
    {
      name: 'size',
      type: 'text',
      enum: ButtonSizes as any,
      defaultValue: ButtonSizes[1],
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Content' } },
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/hand-click.svg',
})
